<template>
  <b-modal id="duty-station-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form>
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Company Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.compnay_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duty Station</label>
                <div class="col-md-8 mb-3">
                  {{detail.unit_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Department</label>
                <div class="col-md-8 mb-3">
                  {{detail.section_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Unit</label>
                <div class="col-md-8 mb-3">
                  {{detail.unit_unit_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Date of Issue</label>
                <div class="col-md-8 mb-3">
                  {{detail.valid_from}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.valid_until}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Last Modified</label>
                <div class="col-md-8 mb-3">
                  {{detail.last_modified}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BForm, BModal} from 'bootstrap-vue'
export default {
  name: "DetailDutyStationForm",
  components:{
    BForm,
    BModal
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{

      }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          this.detail = this.data
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.detail = {

      }
      this.$refs.modal.hide()
    }
  }
}
</script>